import {report_error} from "@cling/lib.shared.debug/index"
import {init as init_auth} from "@cling/lib.web.auth/index"
import {handle_auth_redirect} from "./auth/authenticate"
import {init} from "./entry"
import {start_web_app} from "./startup/startup"
import {watchdog} from "./startup/watchdog"

if (process.env.NODE_ENV !== "test") {
    ;(async function start() {
        init()
        if (!cling.frontend_only) {
            init_auth({is_dev: cling.dev})
            await handle_auth_redirect()
        }
        watchdog(start_web_app)
    })().catch(report_error)
}
